/* eslint-disable react/prop-types */
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  makeStyles,
  withStyles,
  useMediaQuery,
  Typography,
  Box,
  Tooltip,
} from "@material-ui/core";
import {
  setCacheScenario,
  setSelectedScenario,
  setReferenceScenario,
  setCacheReferenceScenario,
} from "app/scenarios/duck/slices";
import _ from "lodash";
import { currentDefaultScenario } from "lib/utils/scenarios";
import { getCycleTypeId } from "lib/utils/cycles";
import { useSelector, useDispatch } from "react-redux";
import { changeSelectedScenarioAsyncAction } from "app/scenarios/duck/actions";
import { ReactComponent as TpoLogo } from "resources/tpo-logo.svg";
import { ReactComponent as Assortment } from "resources/assortment-logo.svg";
import { ReactComponent as CancelIcon } from "resources/cancel-icon.svg";
import { NavLink, useRouteMatch } from "react-router-dom";
import { BsArrowsAngleContract } from "react-icons/bs";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import {
  RiBubbleChartLine,
  RiHistoryLine,
  RiPriceTag3Line,
  RiCalendar2Line,
} from "react-icons/ri";
import mixpanelTrack from "app/common/MixpanelComponent";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    width: "100%",
    height: "100%",
    padding: "25px",
    flexDirection: "column",
    alignItems: "center",
    display: "flex",
    backgroundColor: "#FAFAFA",
    boxshadow: "0px 1px 4px rgba(0, 0, 0, 0.2)",
  },
  dialogContentSmall: {
    width: "80%",
    height: "100%",
    padding: "25px",
    flexDirection: "column",
    alignItems: "center",
    display: "flex",
    backgroundColor: "#FAFAFA",
  },
  dialogRoot: {
    maxWidth: "1050px",
  },
  titleText: {
    marginTop: "50px",
    paddingLeft: "55px",
    color: "black",
  },
  subtitleText: {
    paddingLeft: "55px",
    color: "#6C6C6C",
  },
  dialogTitleContainer: {
    display: "flex",
    flexDirection: "row",
  },
  textContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  menuContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  firstRow: {
    display: "flex",
    flexDirection: "row",
  },
  secondRow: {
    display: "flex",
    flexDirection: "row",
    marginTop: "20px",
    marginBottom: "20px",
  },
  titleTextRow: {
    fontWeight: "bold",
    color: "black",
  },
  titleTextRowDisabled: {
    fontWeight: "bold",
    color: "gray",
  },
  textRow: {
    color: "#6C6C6C",
    width: "175px",
    marginTop: "2px",
  },
  bodyTextRow: {
    flexDirection: "column",
    marginRight: "20px",
    marginLeft: "20px",
    marginBottom: "20px",
    textAlign: "center",
  },
  icon: {
    marginTop: "20px",
    marginBottom: "20px",
    width: "66px",
    height: "66px",
    color: theme.palette.primary.main,
  },
  iconHover: {
    marginTop: "20px",
    marginBottom: "10px",
    width: "66px",
    height: "44px",
  },
  iconDisabled: {
    marginTop: "20px",
    marginBottom: "20px",
    width: "66px",
    height: "66px",
    color: "gray",
  },
  itemMenuContainer: {
    paddingTop: "20px",
    paddingBottom: "20px",
    marginLeft: "25px",
    backgroundColor: "white",
    borderRadius: "3px",
    boxShadow: "0px 1.68992px 3.37984px rgba(0, 0, 0, 0.05)",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "3px",
      color: "white",
      "& $textRow": {
        color: "white",
      },
      "& $titleTextRow": {
        color: "white",
      },
      "& $icon": {
        color: "white",
      },
    },
  },
  itemMenuContainerHover: {
    paddingTop: "10px",
    marginLeft: "25px",
    paddingBottom: "2px",
    backgroundColor: "white",
    borderRadius: "3px",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "3px",
      color: "white",
      "& $textRow": {
        color: "white",
      },
      "& $titleTextRow": {
        color: "white",
      },
      "& $icon": {
        color: "white",
      },
    },
  },
  itemMenuContainerDisabled: {
    paddingTop: "20px",
    paddingBottom: "20px",
    marginLeft: "25px",
    backgroundColor: "white",
    borderRadius: "3px",
    boxShadow: "0px 1.68992px 3.37984px rgba(0, 0, 0, 0.05)",
  },
  itemMenuContainerDisabledStart: {
    paddingTop: "20px",
    paddingBottom: "20px",
    backgroundColor: "white",
    borderRadius: "3px",
    boxShadow: "0px 1.68992px 3.37984px rgba(0, 0, 0, 0.05)",
  },
  itemMenuContainerStart: {
    paddingTop: "20px",
    paddingBottom: "20px",
    backgroundColor: "white",
    borderRadius: "3px",
    boxShadow: "0px 1.68992px 3.37984px rgba(0, 0, 0, 0.05)",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "3px",
      color: "white",
      "& $textRow": {
        color: "white",
      },
      "& $titleTextRow": {
        color: "white",
      },
      "& $icon": {
        color: "white",
      },
    },
  },
  itemMenuContainerStartHover: {
    paddingTop: "10px",
    paddingBottom: "2px",
    backgroundColor: "white",
    borderRadius: "3px",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "3px",
      color: "white",
      "& $textRow": {
        color: "white",
      },
      "& $titleTextRow": {
        color: "white",
      },
      "& $icon": {
        color: "white",
      },
    },
  },
  iconcontainer: {
    textAlign: "center",
  },
  activeLink: {
    textDecoration: "none",
    "& $titleTextRow": {
      color: "black",
    },
  },
  containerCancelIcon: {
    width: "64px",
    height: "26px",
  },
  link: {
    textDecoration: "none",
  },
  tooltipTitle: {
    fontWeight: "bold",
    fontSize: "11px",
  },
  tooltipContainer: { padding: "5px" },
}));

const MenuDialogComponent = ({ open = false, handleClose }) => {
  const classes = useStyles();
  const { url } = useRouteMatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const scenariosSlice = useSelector((state) => state.scenarios);
  const cycleSlice = useSelector((state) => state.cycle);
  const competitorCompaniesSlice = useSelector((state) =>
    _.filter(state.companies, (company) => company.is_client_company === false)
  );
  const [hover, setHover] = useState({
    pricing: false,
    competitors: false,
    tpo: false,
    elasticity: false,
    demand: false,
    history: false,
  });

  const mouseOver = (value) => {
    setHover({ [value]: true });
  };

  const mouseOut = (value) => {
    setHover({ [value]: false });
  };

  const handleCloseButton = () => {
    handleClose();
  };

  const isCycleTypeExist = (condition) => {
    return (
      _.find(
        cycleSlice.list,
        (cycle) => cycle.cycle_type_id === condition[0]?.id
      ) !== undefined
    );
  };

  const ifTypePricingExist = isCycleTypeExist(
    getCycleTypeId("Pricing", cycleSlice)
  );
  const ifTypeTpoExist = isCycleTypeExist(
    getCycleTypeId("Trade Promotions", cycleSlice)
  );
  const ifTypeDailyTpExist = isCycleTypeExist(
    getCycleTypeId("Daily Trade Promotions", cycleSlice)
  );
  const ifTypeAnnualExist = isCycleTypeExist(
    getCycleTypeId("Pricing 2.0", cycleSlice)
  );

  const handleCurrentScenario = (cycleLabelType) => {
    // If we don't have scenario set in cache means that we don't have scenario selected for the cycleType specified.
    if (_.isEmpty(scenariosSlice.setCacheScenario[cycleLabelType])) {
      const selectedScenarioTotal = currentDefaultScenario(
        cycleLabelType,
        scenariosSlice.totalsByScenarioId,
        cycleSlice
      );
      // Finally, we need to request the scenario estimations to the server and set the current scenario selected and set the specific scenario type selected.
      dispatch(
        changeSelectedScenarioAsyncAction(selectedScenarioTotal?.scenario_id)
      );
      dispatch(
        setCacheScenario({
          [cycleLabelType]: selectedScenarioTotal,
        })
      );
      dispatch(
        setCacheReferenceScenario({
          [cycleLabelType]: selectedScenarioTotal,
        })
      );
      // If we have scenario selected for this cycle and the scenario selected is not equal to the cache scenario we need to change the selected scenario.
    } else if (
      scenariosSlice.setCacheScenario[cycleLabelType].scenario_id !==
      scenariosSlice.selectedScenario.scenario_id
    ) {
      dispatch(
        setSelectedScenario(scenariosSlice.setCacheScenario[cycleLabelType])
      );
      dispatch(
        setReferenceScenario(
          scenariosSlice.setCacheReferenceScenario[cycleLabelType]
        )
      );
    }
  };

  const handleMultipleCycles = () => {
    mixpanelTrack(`Pricing module visited`);
    if (ifTypePricingExist) {
      handleCurrentScenario("Pricing");
    } else {
      handleCurrentScenario("Pricing 2.0");
    }
  };

  const handleTpoOrDailytpCycles = () => {
    if (ifTypeTpoExist) {
      handleCurrentScenario("Trade Promotions");
    } else {
      handleCurrentScenario("Daily Trade Promotions");
    }
  };

  const StyledDialogTitle = withStyles(() => ({
    root: {
      padding: "5px",
      backgroundColor: "#FAFAFA",
    },
  }))(DialogTitle);

  const StyledButton = withStyles(() => ({
    root: {
      paddingRight: "14px",
      paddingBottom: "9px",
      flex: 1,
      direction: "rtl",
      flexDirection: "row",
      alignItems: "end",
      color: "#000000",
      "&:hover": {
        backgroundColor: "#FAFAFA",
      },
    },
    label: {
      justifyContent: "normal",
      fontSize: "17px",
      fontWeight: "bold",
    },
  }))(Button);

  const StyledTypography = withStyles(() => ({
    root: {
      // flex: 1,
      direction: "ltr",
      flexDirection: "row-reverse",
      fontWeight: "bold",
      fontSize: "17px",
    },
  }))(Typography);

  const StyledTooltip = withStyles(() => ({
    tooltip: {
      backgroundColor: "#484B5C",
    },
  }))(Tooltip);

  const textTitle = (title, content) => (
    <div className={classes.tooltipContainer}>
      <div className={classes.tooltipTitle}>{title}</div>
      <div>{content}</div>
    </div>
  );

  let coompetitorsLink = (
    <StyledTooltip title={textTitle("Competitors")} placement="right">
      <Box className={classes.itemMenuContainerDisabled}>
        <Box className={classes.iconcontainer}>
          <BsArrowsAngleContract className={classes.iconDisabled} />
        </Box>
        <Box className={classes.bodyTextRow}>
          <Typography variant="body1" className={classes.titleTextRowDisabled}>
            Competitors
          </Typography>
          <Typography variant="body2" className={classes.textRow}>
            Be the winner with AI
          </Typography>
        </Box>
      </Box>
    </StyledTooltip>
  );
  if (_.isEmpty(competitorCompaniesSlice) === false) {
    coompetitorsLink = (
      <NavLink
        to={`${url}/competitors`}
        activeClassName={classes.activeLink}
        className={classes.link}
      >
        <Box
          className={`${
            hover.competitors
              ? classes.itemMenuContainerHover
              : classes.itemMenuContainer
          }`}
          onClick={() => handleCloseButton()}
          onMouseOver={() => mouseOver("competitors")}
          onMouseLeave={() => mouseOut("competitors")}
        >
          <Box className={classes.iconcontainer}>
            <BsArrowsAngleContract
              className={`${
                hover.competitors ? classes.iconHover : classes.icon
              }`}
            />
          </Box>
          <Box className={classes.bodyTextRow}>
            <Typography variant="body1" className={classes.titleTextRow}>
              Competitors
            </Typography>
            {hover.competitors ? (
              <Typography variant="body2" className={classes.textRow}>
                Discover how your promotion strategy will be affected by your
                competitors.
              </Typography>
            ) : (
              <Typography variant="body2" className={classes.textRow}>
                Be the winner with AI
              </Typography>
            )}
          </Box>
        </Box>
      </NavLink>
    );
  }

  return (
    <Dialog
      open={open}
      onBackdropClick={() => handleCloseButton()}
      fullWidth
      maxWidth="md"
      disableRestoreFocus
      classes={{
        paperWidthMd: classes.dialogRoot,
      }}
    >
      <StyledDialogTitle>
        <div className={classes.dialogTitleContainer}>
          <div className={classes.textContainer}>
            <StyledTypography variant="h6" className={classes.titleText}>
              Predictive RGM platform
            </StyledTypography>
            <Typography variant="body2" className={classes.subtitleText}>
              Scale RGM practices driven by AI across your entire organization
            </Typography>
          </div>
          <div className={classes.containerCancelIcon}>
            <StyledButton disableRipple onClick={() => handleCloseButton()}>
              <CancelIcon fill="black" />
            </StyledButton>
          </div>
        </div>
      </StyledDialogTitle>
      <DialogContent
        className={
          isSmallScreen ? classes.dialogContentSmall : classes.dialogContent
        }
      >
        <Box className={classes.menuContainer}>
          <Box className={classes.firstRow}>
            {ifTypeTpoExist || ifTypeDailyTpExist ? (
              <NavLink
                to={`${url}`}
                exact
                activeClassName={classes.activeLink}
                className={classes.link}
                onClick={() => handleTpoOrDailytpCycles()}
              >
                <Box
                  className={`${
                    hover.tpo
                      ? classes.itemMenuContainerStartHover
                      : classes.itemMenuContainerStart
                  }`}
                  onClick={() => handleCloseButton()}
                  onMouseOver={() => mouseOver("tpo")}
                  onMouseLeave={() => mouseOut("tpo")}
                >
                  <Box className={classes.iconcontainer}>
                    <TpoLogo
                      fill={hover.tpo ? "white " : "#E86861"}
                      className={`${
                        hover.tpo ? classes.iconHover : classes.icon
                      }`}
                    />
                  </Box>
                  <Box className={classes.bodyTextRow}>
                    <Typography
                      variant="body1"
                      className={classes.titleTextRow}
                    >
                      TPo
                    </Typography>
                    {hover.tpo ? (
                      <Typography variant="body2" className={classes.textRow}>
                        Accelerate your sales and generate additional volume &
                        margin thanks to a wise investment optimization
                      </Typography>
                    ) : (
                      <Typography variant="body2" className={classes.textRow}>
                        Optimize trade promotions
                      </Typography>
                    )}
                  </Box>
                </Box>
              </NavLink>
            ) : (
              <StyledTooltip
                title={textTitle(
                  " TPo",
                  "There are no promotional cycles uploaded"
                )}
                placement="right"
              >
                <Box className={classes.itemMenuContainerDisabledStart}>
                  <Box className={classes.iconcontainer}>
                    <TpoLogo
                      fill="gray"
                      className={`${classes.iconDisabled}`}
                    />
                  </Box>
                  <Box className={classes.bodyTextRow}>
                    <Typography
                      variant="body1"
                      className={classes.titleTextRowDisabled}
                    >
                      TPo
                    </Typography>
                    <Typography variant="body2" className={classes.textRow}>
                      Optimize trade promotions
                    </Typography>
                  </Box>
                </Box>
              </StyledTooltip>
            )}
            {ifTypePricingExist || ifTypeAnnualExist ? (
              <NavLink
                to={`${url}/pricing`}
                exact
                activeClassName={classes.activeLink}
                className={classes.link}
                onClick={() => handleMultipleCycles()}
              >
                <Box
                  className={`${
                    hover.pricing
                      ? classes.itemMenuContainerHover
                      : classes.itemMenuContainer
                  }`}
                  onClick={() => handleCloseButton()}
                  onMouseOver={() => mouseOver("pricing")}
                  onMouseLeave={() => mouseOut("pricing")}
                >
                  <Box className={classes.iconcontainer}>
                    <RiPriceTag3Line
                      className={`${
                        hover.pricing ? classes.iconHover : classes.icon
                      }`}
                    />
                  </Box>
                  <Box className={classes.bodyTextRow}>
                    <Typography
                      variant="body1"
                      className={classes.titleTextRow}
                    >
                      Pricing
                    </Typography>
                    {hover.pricing ? (
                      <Typography variant="body2" className={classes.textRow}>
                        Find the price combination that optimizes your volume &
                        margin subject to your operational restrictions
                      </Typography>
                    ) : (
                      <Typography variant="body2" className={classes.textRow}>
                        Find the best price scenario
                      </Typography>
                    )}
                  </Box>
                </Box>
              </NavLink>
            ) : (
              <StyledTooltip
                title={textTitle(
                  "Pricing",
                  "There are no pricing cycles uploaded"
                )}
                placement="right"
              >
                <Box className={classes.itemMenuContainerDisabled}>
                  <Box className={classes.iconcontainer}>
                    <RiPriceTag3Line
                      fill="gray"
                      className={`${classes.iconDisabled}`}
                    />
                  </Box>
                  <Box className={classes.bodyTextRow}>
                    <Typography
                      variant="body1"
                      className={classes.titleTextRowDisabled}
                    >
                      Pricing
                    </Typography>
                    <Typography variant="body2" className={classes.textRow}>
                      Find the best price scenario
                    </Typography>
                  </Box>
                </Box>
              </StyledTooltip>
            )}
            <StyledTooltip
              title={textTitle("Assortment", "Available soon")}
              placement="right"
            >
              <Box className={classes.itemMenuContainerDisabled}>
                <Box className={classes.iconcontainer}>
                  <Assortment
                    fill="gray"
                    className={`${classes.iconDisabled}`}
                  />
                </Box>
                <Box className={classes.bodyTextRow}>
                  <Typography
                    variant="body1"
                    className={classes.titleTextRowDisabled}
                  >
                    Assortment
                  </Typography>
                  <Typography variant="body2" className={classes.textRow}>
                    Boost & remove skus
                  </Typography>
                </Box>
              </Box>
            </StyledTooltip>

            {coompetitorsLink}
          </Box>
          <Box className={classes.secondRow}>
            <NavLink
              to={`${url}/demand`}
              activeClassName={classes.activeLink}
              className={classes.link}
            >
              <Box
                className={`${
                  hover.demand
                    ? classes.itemMenuContainerHover
                    : classes.itemMenuContainer
                }`}
                onClick={() => handleCloseButton()}
                onMouseOver={() => mouseOver("demand")}
                onMouseLeave={() => mouseOut("demand")}
              >
                <Box className={classes.iconcontainer}>
                  <RiCalendar2Line
                    className={`${
                      hover.demand ? classes.iconHover : classes.icon
                    }`}
                  />
                </Box>
                <Box className={classes.bodyTextRow}>
                  <Typography variant="body1" className={classes.titleTextRow}>
                    Demand Planning
                  </Typography>
                  {hover.demand ? (
                    <Typography variant="body2" className={classes.textRow}>
                      Efficient production scheduling for the next 2 years. Make
                      just what will be sold
                    </Typography>
                  ) : (
                    <Typography variant="body2" className={classes.textRow}>
                      Make just what will be sold
                    </Typography>
                  )}
                </Box>
              </Box>
            </NavLink>
            <NavLink
              to={`${url}/elasticity`}
              activeClassName={classes.activeLink}
              className={classes.link}
            >
              <Box
                className={`${
                  hover.elasticity
                    ? classes.itemMenuContainerHover
                    : classes.itemMenuContainer
                }`}
                onClick={() => handleCloseButton()}
                onMouseOver={() => mouseOver("elasticity")}
                onMouseLeave={() => mouseOut("elasticity")}
              >
                <Box className={classes.iconcontainer}>
                  <RiBubbleChartLine
                    className={`${
                      hover.elasticity ? classes.iconHover : classes.icon
                    }`}
                  />
                </Box>
                <Box className={classes.bodyTextRow}>
                  <Typography variant="body1" className={classes.titleTextRow}>
                    Elasticities
                  </Typography>
                  {hover.elasticity ? (
                    <Typography variant="body2" className={classes.textRow}>
                      Own & Cross predictive elasticities. Unravel the
                      interrelationships between your products
                    </Typography>
                  ) : (
                    <Typography variant="body2" className={classes.textRow}>
                      Refine your strategy
                    </Typography>
                  )}
                </Box>
              </Box>
            </NavLink>
            <NavLink
              to={`${url}/history`}
              activeClassName={classes.activeLink}
              className={classes.link}
            >
              <Box
                className={`${
                  hover.history
                    ? classes.itemMenuContainerHover
                    : classes.itemMenuContainer
                }`}
                onClick={() => handleCloseButton()}
                onMouseOver={() => mouseOver("history")}
                onMouseLeave={() => mouseOut("history")}
              >
                <Box className={classes.iconcontainer}>
                  <RiHistoryLine
                    className={`${
                      hover.history ? classes.iconHover : classes.icon
                    }`}
                  />
                </Box>
                <Box className={classes.bodyTextRow}>
                  <Typography variant="body1" className={classes.titleTextRow}>
                    History
                  </Typography>
                  {hover.history ? (
                    <Typography variant="body2" className={classes.textRow}>
                      One source of truth, harmonized consumption & shipment
                      databases. Avoid tactics that didn’t work
                    </Typography>
                  ) : (
                    <Typography variant="body2" className={classes.textRow}>
                      Learn from the past
                    </Typography>
                  )}
                </Box>
              </Box>
            </NavLink>
            <StyledTooltip
              title={textTitle("Newscast", "Available soon")}
              placement="right"
            >
              <Box className={classes.itemMenuContainerDisabled}>
                <Box className={classes.iconcontainer}>
                  <HiOutlineSpeakerphone
                    className={`${classes.iconDisabled}`}
                  />
                </Box>
                <Box className={classes.bodyTextRow}>
                  <Typography
                    variant="body1"
                    className={classes.titleTextRowDisabled}
                  >
                    Newscast
                  </Typography>
                  <Typography variant="body2" className={classes.textRow}>
                    Go beyond, understand why
                  </Typography>
                </Box>
              </Box>
            </StyledTooltip>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default MenuDialogComponent;
